import { Button } from "@/components/ui/button";
import { SIGN_IN_PARAM, type OAuthProviderSlug } from "@/lib/auth/oauth-providers";

const PROVIDERS: ReadonlyArray<{ slug: OAuthProviderSlug; label: string }> = [
  { slug: "google", label: "Google" },
  { slug: "microsoft", label: "Microsoft" },
  { slug: "apple", label: "Apple" },
  { slug: "linkedin", label: "LinkedIn" },
];

function currentPage(): string {
  if (typeof window === "undefined") return "/";
  const url = new URL(window.location.href);
  url.searchParams.delete(SIGN_IN_PARAM);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function oauthStartHref(slug: OAuthProviderSlug, returnTo: string = currentPage()): string {
  const params = new URLSearchParams({ provider: slug, returnTo });
  return `/api/auth/oauth/start?${params.toString()}`;
}

export function SocialSignIn() {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3 text-xs text-muted-foreground">
        <span className="h-px flex-1 bg-border" />
        or
        <span className="h-px flex-1 bg-border" />
      </div>
      <div className="grid grid-cols-4 gap-2">
        {PROVIDERS.map(({ slug, label }) => (
          <Button key={slug} variant="outline" asChild>
            <a href={oauthStartHref(slug)} aria-label={`Continue with ${label}`}>
              <img src={`/brand/${slug}.svg`} alt="" width={20} height={20} />
            </a>
          </Button>
        ))}
      </div>
    </div>
  );
}
